import React from 'react'
import { normalizedWarrantName } from '@finance-lab/utils/shared'
import { WarrantEntity } from '../../types/WarrantEntity'

type WarrantEntityWithNames = Pick<WarrantEntity, 'instrumentName' | 'companyName' | 'name' | 'instrumentSymbol'>

function WarrantName({ warrant }: { warrant: WarrantEntityWithNames }) {
    return <>{normalizedWarrantName(warrant)}</>
}

export { WarrantName }
